import {SetCompanySettings, Next, SetGoal, SetServiceType} from "./actions";
import {CompanyLeadState} from "./companyState";
import type {CompanyActions} from "./companyState.types";
import {companyActions} from "./companyState.types";

export default CompanyLeadState;

export {companyActions, Next, SetGoal, SetServiceType, SetCompanySettings};
export type {CompanyActions};
